import queryString from 'query-string';
import http from '../httpConfig';
import { API_ENDPOINTS } from '../utils/apiConstant';
import { buildPagingResponse } from '../utils/methods';
import { PaymentList, PaymentApi } from '../interfaces/payment.interface';

const list = (payload: PaymentList) => {
  const { invoiceId, payment_method, payment_type, account_id, date_from, date_to, ...others } = payload;
  const paging = buildPagingResponse(others);
  const url = `${API_ENDPOINTS.listPayments}?${queryString.stringify(paging)}`;

  return http.post(url, {
    search: "",
    is_active: 1,
    invoice_id: invoiceId,
    payment_method,
    payment_type,
    account_id,
    date_from,
    date_to
  });
};

const kpis = (invoiceId: string) => {
  return http.get(`${API_ENDPOINTS.paymentKpis}?invoice_id=${invoiceId}`);
};

const add = (payload: PaymentApi) => {
  return http.post(API_ENDPOINTS.payments, payload);
};

const edit = (id: string, payload: PaymentApi) => {
  return http.put(`${API_ENDPOINTS.payments}/${id}`, payload);
};

const remove = (id: string) => {
  return http.delete(`${API_ENDPOINTS.payments}/${id}`);
};

const getAccountLookup = (payload: any) => {
  return http.get(`${API_ENDPOINTS.lookupAccounts}?search=${payload.searchText || ''}`);
};

const PaymentService = {
  list,
  kpis,
  add,
  edit,
  remove,
  getAccountLookup
};

export default PaymentService;
